// extracted by mini-css-extract-plugin
export default {"header":"KR","light":"LR","dark":"MR","headertitle":"NR","fname":"OR","headerContent":"PR","right":"QR","descriptionwrapper":"RR","appear":"SR","second":"TR","third":"UR","forth":"VR"};
    if(module.hot) {
      // 1721922367870
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  